import React from 'react';

export default function StepCard({ step }) {

    const { icon, title, subTitle, line } = step

    return(
    <div className='flex justify-start items-start gap-x-4'>
        <img src={ icon } alt='check mark'/>

        <div className='flex gap-x-4'>
            {line && <img className='mt-8' src={'/ambassador/dash.png'} alt='line'/>}
            <div className='flex flex-col gap-y-2 font-matter'>
                <h4 className='font-semibold text-lg md:text-lg'>{ title }</h4>
                { subTitle[0] }
            </div>
        </div>
    </div>
    );
}
